module.exports = __webpack_public_path__ + "media/images/empresa/emp_mas-9bc3f9ed647a3cc2e7bfa3a1a469a001.svg";